import {useEffect, useRef} from 'react';
import {useReservation} from 'context/reservation';
import {useIdleDetector} from '@chekin/shared';
import {removeExpiredSessions} from 'components/sessions/utils';
import {useSessionExpiryPolicy} from 'components/sessions/useSessionExpiryPolicy';
import {
  SessionCloseModal,
  type SessionCloseModalRef,
} from 'components/sessions/SessionCloseModal/SessionCloseModal';

export const ExpireSessionCloseModal = () => {
  const {reservationId} = useReservation();
  const modalRef = useRef<SessionCloseModalRef>(null);
  const {enabled, inactivityLimit, countdown, onExpire} = useSessionExpiryPolicy();

  useEffect(() => {
    removeExpiredSessions();
  }, []);

  useIdleDetector({
    enabled,
    inactivityLimit,
    onIdle: () => modalRef.current?.open(),
  });

  return (
    <SessionCloseModal
      ref={modalRef}
      reservationId={reservationId ?? ''}
      initialTime={countdown}
      onExpire={onExpire}
    />
  );
};
